import { ZoomOutMap } from '@mui/icons-material'
import { ReactElement } from 'react'
import { Translate } from 'common'
import { breakpoints } from '../../theme/breakpoints'
import styled from 'styled-components'

interface MagnifyImageMessageProps {
  message: string
  mobileMessage?: string
}

const MagnifyImageMessage = (props: MagnifyImageMessageProps): ReactElement => {
  const { message, mobileMessage } = props
  return (
    <Wrapper>
      <ZoomOutMapStyled />
      <MagnifyMessageDesktop>{Translate(message)}</MagnifyMessageDesktop>
      <MagnifyMessageMobile>
        {Translate(mobileMessage ?? message)}
      </MagnifyMessageMobile>
    </Wrapper>
  )
}

export default MagnifyImageMessage

const Wrapper = styled.div`
  position: relative;
  top: 0px;
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  @media print {
    display: none;
  }
`

const MagnifyMessage = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #050505;
  mix-blend-mode: normal;
  opacity: 0.9;
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 1rem;
`

const MagnifyMessageMobile = styled(MagnifyMessage)`
  display: none;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    display: block;
  }
  @media print {
    display: none;
  }
`

const MagnifyMessageDesktop = styled(MagnifyMessage)`
  display: block;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    display: none;
  }
`

const ZoomOutMapStyled = styled(ZoomOutMap)`
  margin-top: auto;
  margin-bottom: auto;
`
